var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { forwardRef, } from 'react';
import InputWrapper from './input-wrapper';
const Select = forwardRef(function Input(_a, ref) {
    var { afterLabel, className, errorMessage, id, label, required, options, wrapperClassName } = _a, props = __rest(_a, ["afterLabel", "className", "errorMessage", "id", "label", "required", "options", "wrapperClassName"]);
    return (_jsx(InputWrapper, { className: wrapperClassName, afterLabel: afterLabel, id: id, label: label, required: required, errorMessage: errorMessage, children: _jsx("select", Object.assign({ required: required, className: classNames('form-select', className), id: id, ref: ref }, props, { children: options.map(({ value, displayValue, disabled, selected }) => (_jsx("option", { value: value, disabled: disabled, selected: selected, children: displayValue || value }, value || displayValue))) })) }));
});
export default Select;
